module.exports = __webpack_public_path__ + "img/logo.4a3f7fb3.svg";